"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6493],{

/***/ 90010:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'bag-shopping';
var width = 448;
var height = 512;
var aliases = ["shopping-bag"];
var unicode = 'f290';
var svgPathData = 'M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Cd = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 48256:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'certificate';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f0a3';
var svgPathData = 'M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.U = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 46679:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'sliders';
var width = 512;
var height = 512;
var aliases = ["sliders-h"];
var unicode = 'f1de';
var svgPathData = 'M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.cR = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 75503:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), 'KeyboardArrowDown');
exports.Z = _default;

/***/ }),

/***/ 92048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductCard; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faBagShopping__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90010);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faCertificate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48256);
/* harmony import */ var components_ImageWithFallback__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5503);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Rating__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4656);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _data_config_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56513);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57731);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);



var _excluded = ["data"];












function ProductCard(_ref) {
  var product = _ref.data,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, _excluded);

  var plain = props.plain,
      showDistance = props.showDistance,
      hideCTA = props.hideCTA,
      baseUrl = props.baseUrl,
      type = props.type,
      brandInfo = props.brandInfo;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)('Name'),
      productName = _useState[0],
      setProductName = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    // console.log('product: ', product )
    if (product.slug !== '') {
      setProductName(product.slug);
    }
  }, []);

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  return !!product ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(['flex flex-col relative', !plain && 'shadow-md rounded overflow-hidden p-4']),
    children: [!plain && product.brand_verified && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
      icon: _fortawesome_pro_solid_svg_icons_faCertificate__WEBPACK_IMPORTED_MODULE_10__/* .faCertificate */ .U,
      className: 'text-primary absolute top-1 right-4 z-10'
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: !!baseUrl && !baseUrl.includes('undefined') ? "".concat(baseUrl, "/").concat(encodeURIComponent(productName), "/").concat(product.id) : "".concat(product['__typename'] === 'Product' ? '/products' : '/services', "/listing/").concat(encodeURIComponent(productName), "/").concat(product.id),
      passHref: true,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(["relative after:content-[''] after:block", 'after:pb-[75%] mb-2']),
        children: !!product.images ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_ImageWithFallback__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
          src: product.images[0],
          alt: product.name,
          className: "object-cover transition hover:brightness-105 cursor-pointer"
        }) : null
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
      className: "text-xs text-gray-500 mb-1 flex",
      children: [type === 'Product' ? _data_config_json__WEBPACK_IMPORTED_MODULE_5__/* .product.category_mapping */ .O7.Wn[product.category] === undefined ? '' : t("home:".concat(product.category)) : _data_config_json__WEBPACK_IMPORTED_MODULE_5__/* .service.category_mapping */ .Xn.W[product.category] === undefined ? ' ' : t("home:".concat(product.category)), showDistance && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
        className: "ml-auto text-primary font-semibold",
        children: "".concat(product.location.distance, " ").concat(t('home:distance'))
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: !!baseUrl ? "".concat(baseUrl, "/").concat(encodeURIComponent(productName), "/").concat(product.id) : "".concat(product['__typename'] === 'Product' ? 'products' : 'services', "/").concat(!!product.category ? product.category.split('_')[0] : '', "/").concat(encodeURIComponent(productName), "/").concat(product.id),
      passHref: true,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("a", {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("h4", {
          className: "font-bold text-base mb-1 min-h-[80px] flex items-center",
          children: product.name
        })
      })
    }), !!product.brand && product.brand.name !== '' ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
      className: "text-xs text-gray-500 mb-2",
      children: ["By ", product.brand.name]
    }) : !!brandInfo ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
      className: "text-xs text-gray-500 mb-2",
      children: ["By ", brandInfo.name]
    }) : null, (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
      className: "flex flex-grow flex-nowrap items-center mb-4 text-gray-500",
      children: [product.rating ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .Fragment */ .HY, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
          className: "text-xs mr-2",
          children: product.rating.toFixed(1)
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_Rating__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          value: product.rating || 5,
          precision: 0.5,
          readOnly: true,
          className: 'mr-2'
        })]
      }) : null, product.reviews_count ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
        className: "text-xs",
        children: ["(", product.reviews_count, ")"]
      }) : null]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
      className: "text-xs text-gray-500",
      children: product.weight === 'Each' ? t('home:each') : product.weight
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
      className: "flex mb-2",
      children: [product.price > 0 ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
        className: "font-semibold text-2xl leading-0",
        children: ["$", product.price_compare > 0 ? product.price_compare : product.price]
      }) : null, product.deal && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
        className: "ml-auto text-gray-500 font-semibold line-through leading-normal",
        children: ["$", product.price_compare > 0 ? product.price : '']
      })]
    }), !hideCTA && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      variant: 'contained',
      size: 'small',
      className: 'shadow-none',
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_pro_solid_svg_icons_faBagShopping__WEBPACK_IMPORTED_MODULE_12__/* .faBagShopping */ .Cd,
        className: 'mr-2'
      }), t('home:button_ordernow')]
    })]
  }, product.slug) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
      children: t('home:loading')
    })
  });
}

/***/ }),

/***/ 56493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductListing; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSearch.js
var faSearch = __webpack_require__(367);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCertificate.js
var faCertificate = __webpack_require__(48256);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSliders.js
var faSliders = __webpack_require__(46679);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 4 modules
var FormControlLabel = __webpack_require__(58843);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 6 modules
var Checkbox = __webpack_require__(85071);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/OutlinedInput/OutlinedInput.js + 2 modules
var OutlinedInput = __webpack_require__(37058);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 5 modules
var Select = __webpack_require__(10315);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 2 modules
var MenuItem = __webpack_require__(30431);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./components/cards/ProductCard.js
var ProductCard = __webpack_require__(92048);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(3580);
// EXTERNAL MODULE: ./data/config.json
var config = __webpack_require__(56513);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(57731);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/ListContext.js
var ListContext = __webpack_require__(59773);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/listItemTextClasses.js
var listItemTextClasses = __webpack_require__(26336);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
'use client';



const _excluded = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"];











const useUtilityClasses = ownerState => {
  const {
    classes,
    inset,
    primary,
    secondary,
    dense
  } = ownerState;
  const slots = {
    root: ['root', inset && 'inset', dense && 'dense', primary && secondary && 'multiline'],
    primary: ['primary'],
    secondary: ['secondary']
  };
  return (0,composeClasses/* default */.Z)(slots, listItemTextClasses/* getListItemTextUtilityClass */.L, classes);
};
const ListItemTextRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiListItemText',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${listItemTextClasses/* default.primary */.Z.primary}`]: styles.primary
    }, {
      [`& .${listItemTextClasses/* default.secondary */.Z.secondary}`]: styles.secondary
    }, styles.root, ownerState.inset && styles.inset, ownerState.primary && ownerState.secondary && styles.multiline, ownerState.dense && styles.dense];
  }
})(({
  ownerState
}) => (0,esm_extends/* default */.Z)({
  flex: '1 1 auto',
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, ownerState.primary && ownerState.secondary && {
  marginTop: 6,
  marginBottom: 6
}, ownerState.inset && {
  paddingLeft: 56
}));
const ListItemText = /*#__PURE__*/react.forwardRef(function ListItemText(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiListItemText'
  });
  const {
      children,
      className,
      disableTypography = false,
      inset = false,
      primary: primaryProp,
      primaryTypographyProps,
      secondary: secondaryProp,
      secondaryTypographyProps
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const {
    dense
  } = react.useContext(ListContext/* default */.Z);
  let primary = primaryProp != null ? primaryProp : children;
  let secondary = secondaryProp;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    disableTypography,
    inset,
    primary: !!primary,
    secondary: !!secondary,
    dense
  });
  const classes = useUtilityClasses(ownerState);
  if (primary != null && primary.type !== Typography/* default */.Z && !disableTypography) {
    primary = /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, (0,esm_extends/* default */.Z)({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
      display: "block"
    }, primaryTypographyProps, {
      children: primary
    }));
  }
  if (secondary != null && secondary.type !== Typography/* default */.Z && !disableTypography) {
    secondary = /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, (0,esm_extends/* default */.Z)({
      variant: "body2",
      className: classes.secondary,
      color: "text.secondary",
      display: "block"
    }, secondaryTypographyProps, {
      children: secondary
    }));
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ListItemTextRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [primary, secondary]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ListItemText_ListItemText = (ListItemText);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(75503);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./components/CollapseList.js













function CustomizedList(props) {
  var name = props.name,
      subList = props.subList,
      filter = props.filter,
      handleFilterChange = props.handleFilterChange,
      t = props.t,
      category = props.category,
      index = props.index;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  (0,react.useEffect)(function () {
    if (!!category) {
      var parents = config/* product.categories.map */.O7.bd.map(function (item) {
        return item.slug;
      });
      var openStatus = parents.map(function (item) {
        return category.includes(item);
      });
      setOpen(openStatus[index]);
    }
  }, [category]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      display: 'flex'
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
      sx: {
        pb: open ? 2 : 0
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListItemButton/* default */.Z, {
        alignItems: "flex-start",
        onClick: function onClick() {
          return setOpen(!open);
        },
        sx: {
          // px: 3,
          // pt: 2.5,
          // pb: open ? 0 : 2.5,
          '&:hover, &:focus': {
            '& svg': {
              opacity: open ? 1 : 0
            }
          }
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemText_ListItemText, {
          primary: name,
          primaryTypographyProps: {
            fontSize: 14,
            fontWeight: open ? 'bold' : 'medium',
            lineHeight: '20px',
            mb: '2px' // color: open ? '#108085' : 'black'

          },
          secondaryTypographyProps: {
            noWrap: true,
            fontSize: 12,
            lineHeight: '16px',
            color: 'black'
          },
          sx: {
            my: 0
          }
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyboardArrowDown/* default */.Z, {
          sx: {
            mr: -1,
            opacity: 0,
            transform: open ? 'rotate(-180deg)' : 'rotate(0)',
            transition: '0.2s'
          }
        })]
      }), open && subList.map(function (item) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: item.name === t('home:allAbove') ? t('home:allAbove') : t("home:".concat(item.slug))
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.categories ? filter.categories.includes(item.slug) : false,
            onChange: function onChange(e) {
              return handleFilterChange('categories', item.slug);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, item.slug + item.name);
      })]
    })
  });
}
;// CONCATENATED MODULE: ./components/views/ProductListing.js







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var SORT_OPTIONS = config/* product.sort */.O7.DY;
var STRAIN_TYPES = config/* product.strainType */.O7.Vc;
var PRICE_RANGES = config/* product.priceRange */.O7.GD;
var WEIGHTS = config/* product.weight */.O7.jQ;
var filter_key_map = {
  categories: 'category',
  deals: 'deal',
  brandVerified: 'brand_verified',
  brands: 'brand',
  priceRanges: 'price',
  weights: 'weight',
  strainTypes: 'strain_type'
};
function ProductListing(props) {
  var products = props.products,
      deals = props.deals,
      brands = props.brands,
      baseUrl = props.baseUrl,
      type = props.type,
      _sort = props._sort,
      _filter = props._filter,
      _page = props._page,
      category = props.category;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(SORT_OPTIONS.find(function (s) {
    return s.sort.sortBy === _sort.sortBy && s.sort.order === _sort.order;
  }) || SORT_OPTIONS[0]),
      sort = _useState[0],
      setSort = _useState[1];

  var handleSortChange = function handleSortChange(event) {
    // console.log('sort changing: ', event)
    setSort(event.target.value);
    var res = sortProduct(event.target.value, filteredProducts);
    setFilteredProducts(res);
  };

  var _useState2 = (0,react.useState)(_filter),
      filter = _useState2[0],
      setFilter = _useState2[1];

  var _useState3 = (0,react.useState)(products),
      filteredProducts = _useState3[0],
      setFilteredProducts = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      searchInput = _useState5[0],
      setSearchInput = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isMobile = _useState6[0],
      setIsMobile = _useState6[1];

  var _useState7 = (0,react.useState)([false, false, false, false, false]),
      parentCategoriesOpenList = _useState7[0],
      setParentCategoriesOpenList = _useState7[1];

  var _useState8 = (0,react.useState)([]),
      localCategories = _useState8[0],
      setLocalCategories = _useState8[1];

  var checkCategories = function checkCategories(current) {
    var global_categories = type === 'Product' ? config/* product.categories */.O7.bd : config/* service.categories */.Xn.b;
    setLocalCategories(global_categories);

    if (type === 'Product' && !filter.categories.includes(current)) {
      filter.categories.push(current);
    }
  };

  (0,react.useEffect)(function () {
    checkCategories(category);
  }, [category]);

  var handleChangeSearchInput = function handleChangeSearchInput(e) {
    setSearchInput(e.target.value);
  };

  var initList = function initList() {
    if (type === 'Service' && _filter['categories'].length > 0) {
      handleFilterChange('categories', _filter['categories']);
    }
  };

  (0,react.useEffect)(function () {
    console.log('at product listing: ', props);
    initList();
    checkCategories();
    setLoaded(true);
  }, []);

  var handleFilterChange = function handleFilterChange(field, value) {
    console.log('filter changed: ', field, value);

    switch (field) {
      case 'deals':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          deals: lodash_default().xor(filter.deals, [value])
        }));
        break;

      case 'categories':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          categories: lodash_default().xor(filter.categories, [value])
        }));
        break;

      case 'brandVerified':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          brandVerified: value
        }));
        break;

      case 'brands':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          brands: lodash_default().xor(filter.brands, [value])
        }));
        break;

      case 'strainTypes':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          strainTypes: lodash_default().xor(filter.strainTypes, [value])
        }));
        break;

      case 'priceRanges':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          priceRanges: (0,helper.toggleArray)(filter.priceRanges, value)
        }));
        break;

      case 'weights':
        setFilter(_objectSpread(_objectSpread({}, filter), {}, {
          weights: lodash_default().xor(filter.weights, [value])
        }));
        break;
    }
  };

  var handleSearch = function handleSearch() {
    if (searchInput === '') {
      var res = filterProduct(filter, products);
      setFilteredProducts(res);
    } else {
      var temp = filteredProducts.filter(function (item) {
        return item.name.toLowerCase().includes(searchInput.toLowerCase());
      });
      setFilteredProducts(temp);
    }
  };

  var clearAll = function clearAll() {
    setSearchInput('');
    var tempFilter = _filter;
    tempFilter.categories = '';
    setFilter(tempFilter);
  };

  var filterProduct = function filterProduct(localFilter, localProducts) {
    console.log('filtering: ', localFilter, localProducts, type);

    if (JSON.stringify(localFilter) !== '{}') {
      var _loop = function _loop(key) {
        if (localFilter.hasOwnProperty(key)) {
          // console.log('started: ', key, localFilter[key], localFilter[key].length > 0)
          if (localFilter[key].length > 0 || typeof localFilter[key] === 'boolean') {
            if (key === 'brandVerified') {
              if (localFilter[key] === true) {
                localProducts = localProducts.filter(function (item) {
                  return item[filter_key_map[key]] === true;
                });
              }
            } else if (key === 'categories' || key === 'brands') {
              if (type === 'Service') {
                if (key === 'categories') {
                  if (localFilter[key].length > 0) {
                    var tempList = [];

                    var _loop2 = function _loop2(i) {
                      var list = localProducts.filter(function (item) {
                        return item.category === localFilter[key][i];
                      });
                      tempList = tempList.concat(list);
                    };

                    for (var i = 0; i < localFilter[key].length; i++) {
                      _loop2(i);
                    }

                    localProducts = tempList;
                  }
                }
              } else {
                var _tempList = [];

                if (key === 'categories') {
                  var _loop3 = function _loop3(_i) {
                    var list = localProducts.filter(function (item) {
                      // console.log('checking item slug: ', item, item[filter_key_map[key]])
                      if (!!item[filter_key_map[key]]) {
                        // console.log('checking here: ', item, filter_key_map[key], item[filter_key_map[key]])
                        if (item[filter_key_map[key]].includes(localFilter[key][_i])) {
                          return item;
                        }
                      }
                    });
                    _tempList = _tempList.concat(list);
                  };

                  for (var _i = 0; _i < localFilter[key].length; _i++) {
                    _loop3(_i);
                  }

                  localProducts = _tempList;
                } else {
                  var _loop4 = function _loop4(_i2) {
                    var list = localProducts.filter(function (item) {
                      // console.log('checking item slug: ', item, item[filter_key_map[key]])
                      if (!!item[filter_key_map[key]]) {
                        // console.log('checking here: ', localFilter[key], item.brand.id)
                        if (item.brand.id.toString() === localFilter[key][_i2]) {
                          return item;
                        }
                      }
                    });
                    _tempList = _tempList.concat(list);
                  };

                  for (var _i2 = 0; _i2 < localFilter[key].length; _i2++) {
                    _loop4(_i2);
                  }

                  localProducts = _tempList;
                }
              }
            } else if (key === 'priceRanges') {
              var _tempList2 = [];

              var _loop5 = function _loop5(_i3) {
                var list = localProducts.filter(function (item) {
                  return item.price >= localFilter[key][_i3].min && item.price < localFilter[key][_i3].max;
                });
                _tempList2 = _tempList2.concat(list);
              };

              for (var _i3 = 0; _i3 < localFilter[key].length; _i3++) {
                _loop5(_i3);
              }

              localProducts = _tempList2;
            } else {
              localProducts = localProducts.filter(function (item) {
                if (localFilter[key].includes(item[filter_key_map[key]])) {
                  return item;
                }
              });
            }
          }
        }
      };

      for (var key in localFilter) {
        _loop(key);
      }
    } else {
      console.log('caught it !');
    }

    console.log('localFiltered: ', localProducts.length);
    return localProducts;
  };

  var sortProduct = function sortProduct(localSort, localProducts) {
    return (0,helper.sortByItem)(localProducts, localSort.sort.sortBy, localSort.sort.order);
  };

  (0,react.useEffect)(function () {
    console.log('filtered products: ', filteredProducts);
  }, [filteredProducts]);
  (0,react.useEffect)(function () {
    if (loaded) {
      var temp = filterProduct(filter, products);
      console.log('sorting : ', sort, temp);
      var res = sortProduct(sort, temp);
      setFilteredProducts(res);
    }
  }, [filter, loaded, sort, products]);
  (0,react.useEffect)(function () {
    if (searchInput === '') {
      handleSearch();
    }
  }, [searchInput]);

  var _useState9 = (0,react.useState)(false),
      mobileOpen = _useState9[0],
      setMobileOpen = _useState9[1];

  (0,react.useEffect)(function () {
    if (loaded) {
      setIsMobile((0,helper.checkMobile)());
    }
  }, [loaded]);

  var handleDrawerToggle = function handleDrawerToggle() {
    setMobileOpen(function (prevState) {
      return !prevState;
    });
  };

  var drawerWidth = 240;

  var drawer = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
    className: "p-5",
    sx: {
      textAlign: 'center'
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      variant: 'text',
      className: 'ml-auto w-auto',
      onClick: clearAll,
      children: t('home:clearall')
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4 ",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:filter_category')
      }), localCategories.map(function (c) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: t("home:".concat(c.slug))
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.categories ? filter.categories.includes(c.slug) : false,
            onChange: function onChange(e) {
              return handleFilterChange('categories', c.slug);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, c.slug);
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:amenities_BrandVerified')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
        label: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
          className: 'text-sm',
          children: [t('home:amenities_BrandVerified'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
            icon: faCertificate/* faCertificate */.U,
            className: 'ml-2 text-primary'
          })]
        }),
        className: 'flex items-center -mb-1',
        control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
          checked: filter.brandVerified,
          onChange: function onChange(e) {
            return handleFilterChange('brandVerified', !filter.brandVerified);
          },
          size: 'small',
          className: 'text-primary-dark'
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:Brands')
      }), brands && brands.length > 0 ? brands.map(function (b) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: b.name
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.brands ? filter.brands.includes(b.id) : false,
            onChange: function onChange(e) {
              return handleFilterChange('brands', b.id);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, b.slug);
      }) : null]
    }), type === 'Product' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:filter_strainType')
      }), STRAIN_TYPES.map(function (t) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: t.label
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.strainTypes ? filter.strainTypes.includes(t.value) : false,
            onChange: function onChange(e) {
              return handleFilterChange('strainTypes', t.value);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, t.value);
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:filter_priceRange')
      }), PRICE_RANGES.map(function (r) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: "".concat(r.min === 0 ? t('home:under') : '$' + r.min).concat(r.min === 0 || r.max === 'Infinity' ? ' ' : ' - ').concat(r.max === 'Infinity' ? t('home:infinity') : '$' + r.max)
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.priceRanges ? filter.priceRanges.includes(r) : false,
            onChange: function onChange(e) {
              return handleFilterChange('priceRanges', r);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, "".concat(String(r.min), "-").concat(String(r.max)));
      })]
    }), type === 'Product' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "mb-4",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "font-semibold text-sm mb-2",
        children: t('home:filter_weight')
      }), WEIGHTS.map(function (w) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'text-sm',
            children: w === 'Each' ? t('home:each') : w
          }),
          className: 'flex items-center -mb-1',
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            checked: !!filter.weights ? filter.weights.includes(w) : false,
            onChange: function onChange(e) {
              return handleFilterChange('weights', w);
            },
            size: 'small',
            className: 'text-primary-dark'
          })
        }, w);
      }) // <Checkbox
      //   checked={!!filter.brands ? filter.brands.includes(b.id) : false}
      //   onChange={e => handleFilterChange('brands', b.id)}
      //   size={'small'} className={'text-primary-dark'}
      // />
      ]
    })]
  });

  var renderMobileFilter = function renderMobileFilter() {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "w-auto",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconButton/* default */.Z, {
          color: "inherit",
          "aria-label": "open drawer",
          edge: "start",
          onClick: handleDrawerToggle,
          sx: {
            display: {
              sm: 'none'
            }
          },
          className: "flex flex-row justify-start",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
            icon: faSliders/* faSliders */.cR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'ml-2 font-semibold min-w-[32px]',
            children: t('home:filter')
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
        component: "nav",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Drawer/* default */.ZP // container={container}
        , {
          variant: "temporary",
          open: mobileOpen,
          onClose: handleDrawerToggle,
          ModalProps: {
            keepMounted: true // Better open performance on mobile.

          },
          sx: {
            display: {
              xs: 'block',
              sm: 'none'
            },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth
            }
          },
          children: drawer
        })
      })]
    });
  };

  var renderCollapseList = function renderCollapseList(c, index) {
    console.log('here: ', c);
    var parent = c.subcategories.find(function (item) {
      return item.slug === c.slug;
    });
    var pushedParent = parent !== undefined;

    if (!pushedParent) {
      c.subcategories.push({
        "name": t('home:allAbove'),
        "slug": c.slug,
        "parent_category": c.slug
      });
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomizedList, {
      category: category,
      index: index,
      t: t,
      name: t("home:".concat(c.slug)),
      subList: c.subcategories,
      filter: filter,
      handleFilterChange: handleFilterChange
    }, c.slug);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    className: isMobile ? "flex flex-col" : "flex gap-8",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      className: isMobile ? "flex flex-col w-full" : "w-3/12",
      children: isMobile ? renderMobileFilter() : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: "flex items-center pb-2 border-b mb-4",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
            icon: faSliders/* faSliders */.cR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            className: 'ml-2 font-semibold min-w-[32px]',
            children: t('home:filter')
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            variant: 'text',
            className: isMobile ? 'ml-auto w-auto' : 'ml-auto min-w-full',
            onClick: clearAll,
            children: t('home:clearall')
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4 ",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:filter_category')
            }), localCategories.map(function (c, index) {
              return type === 'Product' ? renderCollapseList(c, index) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
                label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                  className: 'text-sm',
                  children: t("home:".concat(c.slug))
                }),
                className: 'flex items-center -mb-1',
                control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                  checked: !!filter.categories ? filter.categories.includes(c.slug) : false,
                  onChange: function onChange(e) {
                    return handleFilterChange('categories', c.slug);
                  },
                  size: 'small',
                  className: 'text-primary-dark'
                })
              }, c.slug);
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:amenities_BrandVerified')
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
              label: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                className: 'text-sm',
                children: [t('home:amenities_BrandVerified'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
                  icon: faCertificate/* faCertificate */.U,
                  className: 'ml-2 text-primary'
                })]
              }),
              className: 'flex items-center -mb-1',
              control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                checked: filter.brandVerified,
                onChange: function onChange(e) {
                  return handleFilterChange('brandVerified', !filter.brandVerified);
                },
                size: 'small',
                className: 'text-primary-dark'
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:Brands')
            }), brands ? brands.map(function (b) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
                label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                  className: 'text-sm',
                  children: b.name
                }),
                className: 'flex items-center -mb-1',
                control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                  checked: !!filter.brands ? filter.brands.includes(b.id) : false,
                  onChange: function onChange(e) {
                    return handleFilterChange('brands', b.id);
                  },
                  size: 'small',
                  className: 'text-primary-dark'
                })
              }, b.slug);
            }) : null]
          }), type === 'Product' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:filter_strainType')
            }), STRAIN_TYPES.map(function (t) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
                label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                  className: 'text-sm',
                  children: t.label
                }),
                className: 'flex items-center -mb-1',
                control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                  checked: !!filter.strainTypes ? filter.strainTypes.includes(t.value) : false,
                  onChange: function onChange(e) {
                    return handleFilterChange('strainTypes', t.value);
                  },
                  size: 'small',
                  className: 'text-primary-dark'
                })
              }, t.value);
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:filter_priceRange')
            }), PRICE_RANGES.map(function (r) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
                label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                  className: 'text-sm',
                  children: "".concat(r.min === 0 ? t('home:under') : '$' + r.min).concat(r.min === 0 || r.max === 'Infinity' ? ' ' : ' - ').concat(r.max === 'Infinity' ? t('home:infinity') : '$' + r.max)
                }),
                className: 'flex items-center -mb-1',
                control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                  checked: !!filter.priceRanges ? filter.priceRanges.includes(r) : false,
                  onChange: function onChange(e) {
                    return handleFilterChange('priceRanges', r);
                  },
                  size: 'small',
                  className: 'text-primary-dark'
                })
              }, "".concat(String(r.min), "-").concat(String(r.max)));
            })]
          }), type === 'Product' && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: "mb-4",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: "font-semibold text-sm mb-2",
              children: t('home:filter_weight')
            }), WEIGHTS.map(function (w) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
                label: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                  className: 'text-sm',
                  children: w === 'Each' ? t('home:each') : w
                }),
                className: 'flex items-center -mb-1',
                control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                  checked: !!filter.weights ? filter.weights.includes(w) : false,
                  onChange: function onChange(e) {
                    return handleFilterChange('weights', w);
                  },
                  size: 'small',
                  className: 'text-primary-dark'
                })
              }, w);
            }) // <Checkbox
            //   checked={!!filter.brands ? filter.brands.includes(b.id) : false}
            //   onChange={e => handleFilterChange('brands', b.id)}
            //   size={'small'} className={'text-primary-dark'}
            // />
            ]
          })]
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      className: "flex-grow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControl/* default */.Z, {
        fullWidth: true,
        size: 'small',
        className: 'mt-1',
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OutlinedInput/* default */.Z // label="Search this menu"
        , {
          placeholder: t('home:searchThisMenu'),
          id: 'menu-search',
          onChange: handleChangeSearchInput,
          onKeyDown: function onKeyDown(ev) {
            if (ev.key === 'Enter') {
              // Do code here
              handleSearch();
              ev.preventDefault();
            }
          },
          value: searchInput,
          endAdornment: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
            className: "cursor-pointer",
            icon: faSearch/* faSearch */.wn,
            onClick: handleSearch
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "flex py-4 items-center",
        children: [loaded ? "".concat(t('home:found'), " ").concat(filteredProducts.length) : '', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.Z, {
          value: sort,
          onChange: handleSortChange,
          size: 'small',
          className: "w-52 text-sm bg-white ml-auto",
          children: SORT_OPTIONS.map(function (option) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
              value: option,
              children: t("home:".concat(option.key))
            }, option.label);
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: isMobile ? "grid grid-cols-1" : "grid grid-cols-3 gap-3",
        children: filteredProducts.map(function (product) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductCard/* default */.Z, {
            data: product,
            baseUrl: baseUrl,
            type: type
          }, product.id + product.slug);
        })
      })]
    })]
  });
}

/***/ })

}]);